import Trackers from './tracker/tracker';

jQuery(function() {
    $('.soc-marks__link, .product-card__common-text .soc-square-btn').click(function() {
        let data = this.dataset;
        let trackers = new Trackers();
        trackers.onClickEvent(data);
        var social_box = $(this).parent('div');
        var count = parseInt($('span', social_box).text());
        if (!isNaN(count)) {
            count = count + 1;
            $('span', social_box).text(count);
        }
        window.open(
            $(this).attr('href'),
            'displayWindow',
            'width=700,' +
                'height=400,' +
                'left=200,' +
                'top=100,' +
                'location=no,' +
                'directories=no,' +
                'status=no,' +
                'toolbar=no,' +
                'menubar=no'
        );
        return false;
    });
});



// WEBPACK FOOTER //
// ./blocks/soc-marks.js